/* eslint-disable indent */
/* eslint-disable no-undef */
export default {
	name: "customer-vehicles",
	props:{
		companyId: {
			default: null
		}
	},
	data() {
		return {
			customerVehicles: [],
			customerVehiclesHeadings: [
				{
					text: "Make",
					field: "make"
				},
				{
					text: "Model",
					field: "model"
				},
				{
					text: "Year",
					field: "year"
				},
				{
					text: "Vehicle Registration",
					field: "vehicleRegistration"
				},
				{
					text: "Trailer Registration",
					field: "trailerRegistration"
				},
				{
					text: "Fleet Number",
					field: "fleetNumber"
				},
				{
					text: "Capacity",
					field: "capacity"
				},
				{
					text: "Is Active?",
					field: "isActive"
				}
			],
			pagingDetails:{
				pageNumber: 1,
				pageSize: 10,
				totalPages: 1
			},
			customer: {},
			actionKeys:{
				edit: "edit",
				markAsActiveInactive: "markAsActiveInactive",
				managePeopleToNotify: "managePeopleToNotify"
			},
			customerVehicleMarkAsActiveInactiveModal:{
				showModal: false,
				isSaving: false,
				modalId: "markAsActiveInactiveCustomerVehicleModal",
				heading: "Mark Customer Vehicle As Active/Inactive",
				isActive: null,
				vehicleId: null
			},
			customerVehicleAddOrEditModal:{
				showModal: false,
				isSaving: false,
				modalId: "addOrEditCustomerVehicleModal",
				heading: "Add Customer Vehicle",
				vehicle:{
					vehicleId: null,
					make: {
						value: null,
						hasError: false,
						errorMessage: null
					},
					model: {
						value: null,
						hasError: false,
						errorMessage: null
					},
					year: {
						value: null,
						hasError: false,
						errorMessage: null
					},
					registration: {
						value: null,
						hasError: false,
						errorMessage: null
					},
					capacity: {
						value: null,
						hasError: false,
						errorMessage: null
					},
					trailerRegistration: {
						value: null,
						hasError: false,
						errorMessage: null
					},
					fleetNumber: {
						value: null,
						hasError: false,
						errorMessage: null
					},
					isActive: true
				}
			},
			filterStateChanged: false,
			filter:{
				customerSearchQuery: null,
				activeOrInactiveItems: 1,
				selectedCustomerUserRoleId: null
			},
			activeIsActiveKey:{
				active: 1,
				inactive: 0
			},
			pageNumber: 1,
			pageSize: 100,
			loading: false,
			selectedHeartbeatStatusCodeId: null
		};
	},
	methods: {
		getCustomer(){
			let request = {
				companyId: this.companyId
			};
			customerService.getCompany(request).then(
				successResponse => {
					console.log("successResponse", successResponse);
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						//success
						this.customer = successResponse.data.result;
						this.setBreadcrumbs();
					}
				},
				errorResponse => {
					console.log("errorResponse", errorResponse);
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		getCustomerVehicles(){
			this.loading = true;
			let request = {
				companyId: this.companyId,
				searchQuery: this.filter.customerSearchQuery,
				isActive: castingUtility.toBoolean(this.filter.activeOrInactiveItems),
			};
			customerService.getCompanyVehicles(request).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.customerVehicles = successResponse.data.result;
						for(let i = 0; i < this.customerVehicles.length; i++){
							this.customerVehicles[i].actions = [
								{
									name: "Edit",
									key: this.actionKeys.edit,
									elementId: "btnEditCustomerVehicle"
								},
								{
									name: this.customerVehicles[i].isActive ? "Mark As Inactive" : "Mark As Active",
									key: this.actionKeys.markAsActiveInactive,
									elementId: "btnMarkAsActiveInactiveCustomerVehicle"
								},
								{
									name: "Manage People To Notify",
									key: this.actionKeys.managePeopleToNotify,
									elementId: "btnManagePeopleToNotify"
								}
							];
						}
						this.customerVehicles = dataTableHelper.castFieldValues(this.customerVehicles);
						this.filterStateChanged = false;
					}
					permissionsHelper.setControlsBasedOnPermissions();
					this.loading = false;
				},
				errorResponse => {
					console.log("error", errorResponse);
					this.loading = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		onFilterSearchClicked(){
			console.log("Search filter clicked");
			this.getCustomerVehicles();
		},
		onActiveInactiveFilterSelected(activeOrInactiveKey){
			this.filter.activeOrInactiveItems = activeOrInactiveKey;
			this.filterStateChanged = true;
			console.log("filter", this.filter);
		},
		onAddCustomerVehicleClick(){
			this.customerVehicleAddOrEditModal.showModal = true;
			this.customerVehicleAddOrEditModal.heading = "Add Customer Vehicle";
		},
		onCustomerVehiclesActionClicked(actionAndData){
			console.log("actionAndData", actionAndData);
			switch(actionAndData.action){
				case this.actionKeys.edit:
					this.customerVehicleAddOrEditModal.showModal = true;
					this.customerVehicleAddOrEditModal.heading = "Edit Customer Vehicle";
					this.customerVehicleAddOrEditModal.vehicle.vehicleId = actionAndData.data.vehicleId;
					this.customerVehicleAddOrEditModal.vehicle.make.value = actionAndData.data.make;
					this.customerVehicleAddOrEditModal.vehicle.model.value = actionAndData.data.model;
					this.customerVehicleAddOrEditModal.vehicle.year.value = actionAndData.data.year;
					this.customerVehicleAddOrEditModal.vehicle.registration.value = actionAndData.data.vehicleRegistration;
					this.customerVehicleAddOrEditModal.vehicle.capacity.value = actionAndData.data.capacity;
					this.customerVehicleAddOrEditModal.vehicle.trailerRegistration.value = actionAndData.data.trailerRegistration;
					this.customerVehicleAddOrEditModal.vehicle.fleetNumber.value = actionAndData.data.fleetNumber;
					this.customerVehicleAddOrEditModal.vehicle.isActive = castingUtility.toBoolean(actionAndData.data.isActive);
					break;
				case this.actionKeys.markAsActiveInactive:
					this.customerVehicleMarkAsActiveInactiveModal.showModal = true;
					this.customerVehicleMarkAsActiveInactiveModal.vehicleId = actionAndData.data.vehicleId;
					this.customerVehicleMarkAsActiveInactiveModal.isActive = castingUtility.toBoolean(actionAndData.data.isActive);
					this.customerVehicleMarkAsActiveInactiveModal.heading = "Mark Customer Vehicle" + (this.customerVehicleMarkAsActiveInactiveModal.isActive ? " Inactive - " : " Active - ") + actionAndData.data.vehicleRegistration;
					break;
				case this.actionKeys. managePeopleToNotify:
					this.$router.push("/customers/customerVehicles/peopleToNotify/" + actionAndData.data.vehicleId + "/" + this.companyId);
					break;
			}
		},
		onMarkCustomerVehicleActiveInactiveSelected(isActive){
			this.customerVehicleMarkAsActiveInactiveModal.isActive = isActive;
			console.log("customerVehicleMarkAsActiveInactiveModal.isActive", this.customerVehicleMarkAsActiveInactiveModal.isActive);
		},
		onMarkAsActiveInactiveSaveClick(markAsActive){
			this.customerVehicleMarkAsActiveInactiveModal.isSaving = true;
			let request = {
				vehicleId: this.customerVehicleMarkAsActiveInactiveModal.vehicleId,
				isActive: markAsActive,
				companyId: this.companyId
			};
			customerService.markVehicleAsActiveOrInactive(request).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.getCustomerVehicles();
						this.customerVehicleMarkAsActiveInactiveModal.showModal = false;
						this.customerVehicleMarkAsActiveInactiveModal.isActive = true;
						this.customerVehicleMarkAsActiveInactiveModal.vehicleId = null;
					}
					this.customerVehicleMarkAsActiveInactiveModal.isSaving = false;
				},
				errorResponse => {
					console.log("error", errorResponse);
					this.customerVehicleMarkAsActiveInactiveModal.isSaving = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		onAddOrEditCustomerVehicleModalCloseClick(){
			this.customerVehicleAddOrEditModal.showModal = false;
			this.clearVehicleModel();
		},
		onAddOrEditCustomerVehicleSaveClick(){
			this.customerVehicleAddOrEditModal.isSaving = true;
			let request = {
				companyId: parseInt(this.companyId),
				vehicleId: this.customerVehicleAddOrEditModal.vehicle.vehicleId,
				make: this.customerVehicleAddOrEditModal.vehicle.make.value,
				model: this.customerVehicleAddOrEditModal.vehicle.model.value,
				year: this.customerVehicleAddOrEditModal.vehicle.year.value,
				vehicleRegistration: this.customerVehicleAddOrEditModal.vehicle.registration.value,
				capacity: this.customerVehicleAddOrEditModal.vehicle.capacity.value,
				trailerRegistration: this.customerVehicleAddOrEditModal.vehicle.trailerRegistration.value,
				fleetNumber: this.customerVehicleAddOrEditModal.vehicle.fleetNumber.value,
				isActive: this.customerVehicleAddOrEditModal.vehicle.isActive
			};
			customerService.addOrUpdateCustomerVehicle(request).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						//success
						console.log("success", successResponse);
						if(successResponse.data.customerVehicleValidationResponse.valuesAreValid) {
							this.getCustomerVehicles();
							this.clearVehicleModel();
							this.customerVehicleAddOrEditModal.showModal = false;
						}
						else{
							this.customerVehicleAddOrEditModal.vehicle.make.hasError = successResponse.data.customerVehicleValidationResponse.makeValidationResponse.hasError;
							this.customerVehicleAddOrEditModal.vehicle.make.errorMessage = successResponse.data.customerVehicleValidationResponse.makeValidationResponse.message;
							
							this.customerVehicleAddOrEditModal.vehicle.model.hasError = successResponse.data.customerVehicleValidationResponse.modelValidationResponse.hasError;
							this.customerVehicleAddOrEditModal.vehicle.model.errorMessage = successResponse.data.customerVehicleValidationResponse.modelValidationResponse.message;
							
							this.customerVehicleAddOrEditModal.vehicle.year.hasError = successResponse.data.customerVehicleValidationResponse.yearValidationResponse.hasError;
							this.customerVehicleAddOrEditModal.vehicle.year.errorMessage = successResponse.data.customerVehicleValidationResponse.yearValidationResponse.message;
							
							this.customerVehicleAddOrEditModal.vehicle.registration.hasError = successResponse.data.customerVehicleValidationResponse.vehicleRegistrationValidationResponse.hasError;
							this.customerVehicleAddOrEditModal.vehicle.registration.errorMessage = successResponse.data.customerVehicleValidationResponse.vehicleRegistrationValidationResponse.message;
							
							this.customerVehicleAddOrEditModal.vehicle.capacity.hasError = successResponse.data.customerVehicleValidationResponse.capacityValidationResponse.hasError;
							this.customerVehicleAddOrEditModal.vehicle.capacity.errorMessage = successResponse.data.customerVehicleValidationResponse.capacityValidationResponse.message;
							
							this.customerVehicleAddOrEditModal.vehicle.trailerRegistration.hasError = successResponse.data.customerVehicleValidationResponse.trailerRegistrationValidationResponse.hasError;
							this.customerVehicleAddOrEditModal.vehicle.trailerRegistration.errorMessage = successResponse.data.customerVehicleValidationResponse.trailerRegistrationValidationResponse.message;
						}
					}
					this.customerVehicleAddOrEditModal.isSaving = false;
				},
				errorResponse => {
					//error
					console.log("error", errorResponse);
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
					this.customerVehicleAddOrEditModal.isSaving = false;
				}
			);
		},
		clearVehicleModel() {
			this.customerVehicleAddOrEditModal.vehicle = {
				vehicleId: null,
				make: {
					value: null,
					hasError: false,
					errorMessage: null
				},
				model: {
					value: null,
					hasError: false,
					errorMessage: null
				},
				year: {
					value: null,
					hasError: false,
					errorMessage: null
				},
				registration: {
					value: null,
					hasError: false,
					errorMessage: null
				},
				capacity: {
					value: null,
					hasError: false,
					errorMessage: null
				},
				trailerRegistration: {
					value: null,
					hasError: false,
					errorMessage: null
				},
				fleetNumber: {
					value: null,
					hasError: false,
					errorMessage: null
				},
				isActive: true
			};
		},
		setBreadcrumbs() {
			let pageTitle = "Customer Vehicles - " + this.customer.registeredCompanyName
			storeState.setPageTitleAction(pageTitle);
			breadcrumbsStoreState.updateBreadcrumbs(this.$route, pageTitle);
		}
	},
	mounted: function () {
	},
	watch: {
		companyId: {
			handler: function () {
				if (this.companyId !== null && this.companyId > 0) {
					this.getCustomerVehicles();
					this.getCustomer();
				}
			},
			immediate: true,
			deep: true
		}
	}
};